import React, { useCallback, useEffect, useState } from 'react'
import TextField from '../../../../core/common/textFields/TextField'
import { useLazyGetLocationDetailsByAggressQuery, useLazyGetLocationQuery } from '../../../../services/EndPointsApis';
import { debounce } from 'lodash';

const AddressesWizData = ({ formik, adressConfirm, setAdressConfirm }: any) => {
    const [searchStr, setSearchStr] = useState('');
    const [immediateSearchStr1, setImmediateSearchStr1] = useState('');
    const [immediateSearchStr2, setImmediateSearchStr2] = useState('');
    // zipcode api 
    const [triggerLocation, { data: locationData }] = useLazyGetLocationQuery();
    const [triggerLocation2, { data: locationData2 }] = useLazyGetLocationQuery();
    // addresses api for longitude and latitude 
    const [triggerLongLatM, { data: longLatDataM }] = useLazyGetLocationDetailsByAggressQuery();
    // addresses api for longitude and latitude 
    const [triggerLongLatP, { data: longLatDataP }] = useLazyGetLocationDetailsByAggressQuery();

    // handle sreach for mailing address 
    const handleSearchChange1 = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr1(value);
        delayedSearch1(value);
        formik.setFieldValue("primaryContact.mailingAddress.zipCode", value)
    }
    // handle serach for property address 
    const handleSearchChange2 = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr2(value);
        delayedSearch2(value);
        formik.setFieldValue("primaryContact.propertyAddress.zipCode", value)
    }
    // handle search for latlong 
    const handleSearchLongLat1 = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr2(value);
        delayedSearchLongLat1(value);
        formik.setFieldValue("primaryContact.mailingAddress.addressLine1", value)
    }
    // handle search for latlong 
    const handleSearchLongLat2 = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr2(value);
        delayedSearchLongLat2(value);
        formik.setFieldValue("primaryContact.propertyAddress.addressLine1", value)
    }
    //debounce for mailing address
    const delayedSearch1 = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
            triggerLocation({ ZipCode: searchValue || null })
        }, 1000),
        []
    );
    //debounce for property address
    const delayedSearch2 = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
            triggerLocation2({ ZipCode: searchValue || null })
        }, 1000),
        []
    );
    //debounce for longLat
    const delayedSearchLongLat1 = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
            triggerLongLatM({ ZipCode: searchValue || null })
        }, 1000),
        []
    );
    //debounce for longLat
    const delayedSearchLongLat2 = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
            triggerLongLatP({ ZipCode: searchValue || null })
        }, 1000),
        []
    );

    useEffect(() => {
        if (adressConfirm === true) {
            formik.setFieldValue("primaryContact.propertyAddress.addressLine1", formik?.values?.primaryContact?.mailingAddress?.addressLine1)
            formik.setFieldValue("primaryContact.propertyAddress.addressLine2", formik?.values?.primaryContact?.mailingAddress?.addressLine2)
            formik.setFieldValue("primaryContact.propertyAddress.zipCode", formik?.values?.primaryContact?.mailingAddress?.zipCode)
            formik.setFieldValue("primaryContact.propertyAddress.stateName", formik?.values?.primaryContact?.mailingAddress?.stateName)
            formik.setFieldValue("primaryContact.propertyAddress.cityName", formik?.values?.primaryContact?.mailingAddress?.cityName)
            formik.setFieldValue("primaryContact.propertyAddress.longitude", formik?.values?.primaryContact?.mailingAddress?.longitude)
            formik.setFieldValue("primaryContact.propertyAddress.latitude", formik?.values?.primaryContact?.mailingAddress?.latitude)
        }
    }, [adressConfirm, formik.values])

    useEffect(() => {
        if (locationData && locationData?.result) {
            formik.setFieldValue(
                "primaryContact.mailingAddress.stateName",
                locationData?.result?.state || ''
            );
            formik.setFieldValue(
                "primaryContact.mailingAddress.cityName",
                locationData?.result?.city || ''
            );
        }
    }, [locationData]);

    useEffect(() => {
        if (locationData2 && locationData2?.result) {
            formik.setFieldValue("primaryContact.propertyAddress.stateName", locationData2?.result?.state || '')
            formik.setFieldValue("primaryContact.propertyAddress.cityName", locationData2?.result?.city || '')
        }
    }, [locationData2])

    useEffect(() => {
        if (longLatDataM && longLatDataM?.result) {
            formik.setFieldValue(
                "primaryContact.mailingAddress.latitude",
                longLatDataM?.result?.latitude || ''
            );
            formik.setFieldValue(
                "primaryContact.mailingAddress.longitude",
                longLatDataM?.result?.longitude || ''
            );
        }
    }, [longLatDataM]);

    useEffect(() => {
        if (longLatDataP && longLatDataP?.result) {
            formik.setFieldValue(
                "primaryContact.propertyAddress.latitude",
                longLatDataP?.result?.latitude || ''
            );
            formik.setFieldValue(
                "primaryContact.propertyAddress.longitude",
                longLatDataP?.result?.longitude || ''
            );
        }
    }, [longLatDataP]);

    return (
        <>
            <div className='row mt-2'>
                <h5>Mailing Address</h5>
                <div className="col-md-6">
                    <div className="form-wrap">
                        <TextField
                            label="Address line 1"
                            type="text"
                            required
                            value={formik.values?.primaryContact?.mailingAddress?.addressLine1}
                            onChange={handleSearchLongLat1}
                        //   disabled={viewOnly}
                        />
                    </div>
                    {/* {formik.touched.firstName && formik.errors.firstName && (
            <div className="error">{formik.errors.firstName}</div>
          )} */}
                </div>
                <div className="col-md-6">
                    <div className="form-wrap">
                        <TextField
                            label="Address Line 2 "
                            type="text"
                            {...formik.getFieldProps("primaryContact.mailingAddress.addressLine2")}
                        // disabled={viewOnly}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-wrap">
                        <TextField
                            label="ZipCode "
                            type="text"
                            required
                            value={formik.values.primaryContact.mailingAddress.zipCode}
                            onChange={handleSearchChange1}
                        // {...formik.getFieldProps("primaryContact.mailingAddress.zipCode")}
                        // disabled={viewOnly}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-wrap">
                        <TextField
                            label="State/Region "
                            type="text"
                            required
                            disabled
                            value={locationData?.result?.state}
                            // onChange={() => formik.setFieldValue('primaryContact.mailingAddress.stateName', locationData?.result?.state)}
                            {...formik.getFieldProps("primaryContact.mailingAddress.stateName")}
                        // disabled={viewOnly}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-wrap">
                        <TextField
                            label="City "
                            type="text"
                            required
                            value={locationData?.result?.city}
                            // onChange={() => formik.setFieldValue('primaryContact.mailingAddress.stateName', locationData?.result?.city)}
                            {...formik.getFieldProps("primaryContact.mailingAddress.cityName")}
                        // disabled={viewOnly}
                        />
                    </div>
                </div>
                <div className='col-md-3'>
                    <div className="form-wrap">
                        <TextField
                            label="Longitude "
                            type="text"
                            required
                            {...formik.getFieldProps("primaryContact.mailingAddress.longitude")}
                            disabled
                        />
                    </div>
                </div>
                <div className='col-md-3'>
                    <div className="form-wrap">
                        <TextField
                            label="Latitude "
                            type="text"
                            required
                            {...formik.getFieldProps("primaryContact.mailingAddress.latitude")}
                            disabled
                        />
                    </div>
                </div>

            </div>
            <div className="col-md-12 d-flex justify-content-end">
                <label className="input-label">
                    Property Address Same ?<span className="text-danger"> *</span>
                </label>
                <label className="checkboxs mt-2 mb-5">
                    <input
                        type="checkbox"
                        checked={adressConfirm}
                        onChange={
                            (e: any) => setAdressConfirm(e.target.checked)
                        }
                    // {...formik.getFieldProps("che")}
                    />
                    <span className="checkmarks" />
                </label>
            </div>
            {adressConfirm === false ?
                <div className='row mt-2'>
                    <h5>Property Address</h5>
                    <div className="col-md-6">
                        <div className="form-wrap">
                            <TextField
                                label="Address line 1"
                                type="text"
                                required
                                value={formik.values?.primaryContact.propertyAddress.addressLine1}
                                onChange={handleSearchLongLat2}
                            //   disabled={viewOnly}
                            />
                        </div>

                    </div>
                    <div className="col-md-6">
                        <div className="form-wrap">
                            <TextField
                                label="Address Line 2 "
                                type="text"
                                {...formik.getFieldProps("primaryContact.propertyAddress.addressLine2")}
                            // disabled={viewOnly}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-wrap">
                            <TextField
                                label="ZipCode "
                                type="text"
                                required
                                value={formik.values.primaryContact.propertyAddress.zipCode}
                                onChange={handleSearchChange2}
                            // {...formik.getFieldProps("primaryContact.propertyAddress.zipCode")}
                            // disabled={viewOnly}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-wrap">
                            <TextField
                                label="State/Region "
                                type="text"
                                required
                                {...formik.getFieldProps("primaryContact.propertyAddress.stateName")}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-wrap">
                            <TextField
                                label="City "
                                type="text"
                                required
                                {...formik.getFieldProps("primaryContact.propertyAddress.cityName")}
                            />
                        </div>
                    </div>
                    <div className='col-md-3'>
                        <div className="form-wrap">
                            <TextField
                                label="Longitude "
                                type="text"
                                required
                                {...formik.getFieldProps("primaryContact.propertyAddress.longitude")}
                                disabled
                            />
                        </div>
                    </div>
                    <div className='col-md-3'>
                        <div className="form-wrap">
                            <TextField
                                label="Latitude "
                                type="text"
                                required
                                {...formik.getFieldProps("primaryContact.propertyAddress.latitude")}
                                disabled
                            />
                        </div>
                    </div>
                </div>
                : ''}
        </>
    )
}

export default AddressesWizData